module.exports = __webpack_public_path__ + "img/government-affairs-bg.5b29755a.png";